import React from "react";

const TableHeader = ({tableHeaderArr, option}) => {
    const getHeaders = () => {
        return tableHeaderArr.map((key, ind) => {
            return <th key={ind} scope="col">{key}</th>
        })
    }
    return (
        <thead>
        <tr>
            {getHeaders()}
        </tr>
        </thead>
    )
}

export default TableHeader;
